import { usePermissions } from '../../hooks/usePermissions';
import { Permission } from '../../types/permissions';

import type { ReviewDetail } from './reviewTypes';

/**
 * Whether the viewer may resolve or reopen this item. A gift-pass purchase
 * belongs to no region, so the server lets only a nation-wide writer act on it.
 */
export function useCanWriteReview(detail: ReviewDetail | null): boolean {
  const { hasAnyPermission, hasPermission } = usePermissions();
  if (!hasAnyPermission(Permission.WRITE_PAYMENT_REVIEWS)) return false;
  return detail?.workshop !== null || hasPermission(Permission.BREADTH_WRITE_ALL);
}
